import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import apiService from '../../../services/api';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { checkAuth, user } = useAuth();

  useEffect(() => {
    // Verificar se o usuário agora é PRO
    const verifyProStatus = async () => {
      try {
        await checkAuth();
        // Se já é PRO, vai para o dashboard
        if (user && user.is_pro === 1) {
          setTimeout(() => navigate('/dashboard'), 1500);
        }
      } catch (error) {
        console.error('Erro ao verificar status PRO:', error);
      }
    };

    verifyProStatus();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-4">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Pagamento Aprovado!
          </h2>
          
          <p className="text-gray-600 mb-6">
            Seu pagamento foi aprovado com sucesso. Você agora tem acesso PRO ao Premiei!
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-blue-800 text-sm">
              Após confirmação do pagamento pelo Mercado Pago, seu acesso PRO é ativado automaticamente.
            </p>
          </div>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Ir para Dashboard
          </button>

          <div className="mt-4">
            <button
              onClick={async () => {
                try {
                  await apiService.activatePro();
                  await checkAuth();
                  navigate('/dashboard');
                } catch (e) {
                  console.error(e);
                }
              }}
              className="w-full bg-gray-200 text-gray-900 py-2 px-4 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              Ativar PRO (sandbox)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
